export enum CardTask {
    FOLD = 'fold',
    MATCH = 'match',
    MATCH_CONNECTED_CARD = 'match_connected_card',
    FLIP = 'flip',
    WIGGLE = 'wiggle',
    ZAP = 'zap',
    BOOM = 'boom',
    BOMB = 'bomb',
    ICE = 'ice',
    SCISSOR = 'scissor',
    KEY = 'key',
    PLUS_ONE = 'plus_one',
    PLUS_THREE = 'plus_three',
    PLUS_FIVE = 'plus_five',
    PLUS_STREAK = 'plus_streak',
    PLUS_STREAK_JOKER = 'plus_streak_joker',
    TORNADO = 'tornado',
    FOG_END = 'fog_end',
    ROCK = 'rock',
    ROCK_UPDATE = 'rock_update',
    UNDO_MATCH = 'undo_match',
    UNDO_FOLD = 'undo_fold',
    TNT = 'tnt',
    BULLS_EYE = 'bulls_eye',
    SHUFFLE = 'shuffle',
    JOKER = 'joker',
    REMOVE_THREE_PRE_BOOSTER = 'remove_three_pre_booster',
    REVEAL_CANISTER_PRE_BOOSTER = 'reveal_canister_pre_booster',
    USE_CANISTER_PRE_BOOSTER = 'use_canister_pre_booster',
    REVEAL_JOKER_PRE_BOOSTER = 'reveal_joker_pre_booster',
    RECEIVE_JOKER_PRE_BOOSTER = 'receive_joker_pre_booster',
    UNDO_FLIP = 'undo_flip',
}
